import { styled } from '@mui/material';
import Stack from '@mui/material/Stack';

export const LatencyLayout = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;

  ${({ theme }) => theme.breakpoints.up('lg')} {
    flex-direction: row;
    align-items: flex-start;
  }
`;

export const ControlGroup = styled('div')`
  display: flex;
  flex-wrap: wrap;
  gap: 16px 24px;
  width: 100%;

  ${({ theme }) => theme.breakpoints.up('lg')} {
    flex: 1 0 60%;
  }
`;

export const HostFieldGroup = styled(Stack)`
  flex: 1 1 100%;
  min-width: 0;

  ${({ theme }) => theme.breakpoints.up('md')} {
    flex: 1 1 240px;
  }
`;

export const PeriodFieldGroup = styled(Stack)`
  flex: 1 1 100%;
  min-width: 0;

  ${({ theme }) => theme.breakpoints.up('md')} {
    flex: 0 1 200px;
    max-width: 200px;
  }
`;

export const ButtonsRow = styled('div')`
  display: flex;
  flex-wrap: wrap;
  gap: 16px 24px;
  justify-content: flex-end;
  flex: 1 1 100%;

  ${({ theme }) => theme.breakpoints.up('md')} {
    flex: 0 0 auto;
    margin-left: auto;
  }

  ${({ theme }) => theme.breakpoints.up('lg')} {
    flex-basis: 100%;
    margin-left: 0;
  }
`;

export const DiagramGroup = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  height: 100%;

  ${({ theme }) => theme.breakpoints.up('md')} {
    flex-direction: row;
    align-items: center;
  }

  ${({ theme }) => theme.breakpoints.up('lg')} {
    flex: 1 1 40%;
  }
`;

export const DiagramItem = styled('div')`
  flex: 0 1 50%;
  min-width: 0;
`;

export const ServerDataBox = styled('div')`
  display: flex;
  flex-direction: column;
  border: 1px solid ${({ theme }) => theme.palette.primary['01']};
  color: ${({ theme }) => theme.palette.primary['01']};
  border-radius: 8px;
  background-color: ${({ theme }) => `${theme.palette.primary['01']}30`};
  padding: 8px;
  min-width: 200px;
  align-items: flex-start;
  flex: 1 0 50%;
`;

export const ServerDataBoxContainer = styled('div')`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
`;

export const StatsContainer = styled('div')`
  display: grid;
  gap: 16px;

  grid-template-columns: repeat(2, 1fr);

  ${({ theme }) => theme.breakpoints.down('sm')} {
    grid-template-columns: repeat(1, 1fr);
  }

  ${({ theme }) => theme.breakpoints.up('md')} {
    grid-template-columns: repeat(3, 1fr);
  }

  ${({ theme }) => theme.breakpoints.up('lg')} {
    grid-template-columns: repeat(6, 1fr);
  }
`;

export const PackagesRow = styled(Stack)`
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`;
